var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ctrl-down 1",
    clipPath: "url(#clip0_6068_4926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8748 3.71905L6.4998 7.21905L2.1248 3.71905C2.02224 3.63698 1.90452 3.5759 1.77835 3.53933C1.65219 3.50275 1.52006 3.49137 1.3895 3.50586C1.25894 3.52035 1.13251 3.56041 1.01743 3.62375C0.902355 3.6871 0.800881 3.77249 0.718805 3.87505C0.636729 3.97761 0.575657 4.09534 0.539078 4.2215C0.502498 4.34767 0.491127 4.4798 0.505613 4.61036C0.520099 4.74092 0.560158 4.86735 0.623504 4.98242C0.68685 5.0975 0.772242 5.19898 0.874805 5.28105L5.8748 9.28105C6.05217 9.42306 6.2726 9.50043 6.4998 9.50043C6.72701 9.50043 6.94744 9.42306 7.1248 9.28105L12.1248 5.28105C12.3319 5.11529 12.4647 4.87404 12.494 4.61036C12.5233 4.34668 12.4466 4.08219 12.2808 3.87505C12.1987 3.77249 12.0973 3.6871 11.9822 3.62375C11.8671 3.56041 11.7407 3.52035 11.6101 3.50586C11.3464 3.4766 11.0819 3.55329 10.8748 3.71905Z",
    fill: "#056EE6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6068_4926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/showMore.958866aed5676d3050bcf8d202289b99.svg";
export { ForwardRef as ReactComponent };